export var camelize = function (str) {
    return str.replace(/_(\w)/g, function (_match, capture) { return capture.toUpperCase(); });
};
export var deepCamelize = function (obj) {
    return Object.keys(obj).reduce(function (result, key) {
        if (typeof obj[key] === 'object') {
            result[camelize(key)] = deepCamelize(obj[key]);
            return result;
        }
        result[camelize(key)] = obj[key];
        return result;
    }, {});
};
export var decamelize = function (str) {
    return str.replace(/[A-Z]/g, function (s) { return "_".concat(s.charAt(0).toLowerCase()); });
};
export var capitalize = function (str) {
    if (!str)
        return str;
    return str[0].toUpperCase() + str.slice(1);
};
